"use strict";

exports.__esModule = true;
exports.FilterPopover = FilterPopover;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var FilterPopoverWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FilterPopover__FilterPopoverWrapper",
  componentId: "sc-1tziwej-0"
})(["margin:0 5px;width:100%;.", "{border:none;box-shadow:none;background:none;&:hover{border:none;box-shadow:none;}}"], _core.Classes.BUTTON);
function FilterPopover(props) {
  var popoverContent = props.popoverContent,
    popoverTarget = props.popoverTarget,
    usePortal = props.usePortal,
    position = props.position;
  return /*#__PURE__*/_react["default"].createElement(_core.Popover, {
    canEscapeKeyClose: true,
    enforceFocus: false,
    content: popoverContent,
    usePortal: usePortal || false,
    position: position || _core.Position.BOTTOM_LEFT,
    interactionKind: _core.PopoverInteractionKind.CLICK
  }, /*#__PURE__*/_react["default"].createElement(FilterPopoverWrapper, null, popoverTarget));
}